import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "topBar" }
const _hoisted_2 = { m: "4" }
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_statistic = _resolveComponent("el-statistic")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        size: "large",
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.dialogVisible2 = true))
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
          _createTextVNode("添加优惠卷", -1)
        ]))]),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: $data.tableData,
      border: $data.parentBorder,
      "preserve-expanded-content": $data.preserveExpanded,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "expand" }, {
          default: _withCtx((props) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_row, {
                gutter: 16,
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    xs: 24,
                    sm: 12,
                    md: 6,
                    type: "flex",
                    align: "middle",
                    class: "text-center mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_statistic, {
                        title: "优惠卷数目",
                        value: props.row.data.length
                      }, null, 8, ["value"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, {
                    xs: 24,
                    sm: 12,
                    md: 6,
                    type: "flex",
                    align: "middle",
                    class: "text-center mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_statistic, {
                        value: 
                  props.row.data.filter((item) => item.isUse !== 0).length
                
                      }, {
                        title: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("div", { style: {"display":"inline-flex","align-items":"center"} }, " 已使用 ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_table, {
                data: props.row.data,
                border: $data.childBorder
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "游戏",
                    prop: "gameName"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "抵消金额(元)",
                    prop: "discountAmount"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "用户Id",
                    prop: "userId"
                  }),
                  _createVNode(_component_el_table_column, { label: "状态" }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_tag, {
                        size: "large",
                        type: row.isUse == 0 ? 'warning' : 'success'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.isUse == 0 ? "未使用" : "已使用"), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ]),
                    _: 1
                  }),
                  _cache[13] || (_cache[13] = _createTextVNode("> ", -1)),
                  _createVNode(_component_el_table_column, {
                    label: "密钥",
                    prop: "secretKey"
                  })
                ]),
                _: 1
              }, 8, ["data", "border"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "remark"
        }),
        _createVNode(_component_el_table_column, {
          label: "过期时间",
          prop: "expirationTime"
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "编辑",
          "min-width": "120",
          align: "right"
        }, {
          default: _withCtx((props) => [
            _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "small",
              onClick: ($event: any) => {
            $data.dialogVisible = true;
            $data.selectRemark = props.row.remark;
          }
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode(" 删除 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "small",
              onClick: ($event: any) => {
            $data.selectRemark = props.row.remark;
            $options.exportExcel();
          }
            }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createTextVNode(" 导出Excel ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "border", "preserve-expanded-content"]),
    _createVNode(_component_el_dialog, {
      modelValue: $data.dialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.dialogVisible) = $event)),
      width: "500",
      draggable: "",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($data.dialogVisible = false))
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: $options.delTicket
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode(" 删除 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: $data.form,
          "label-width": "auto",
          style: {"max-width":"600px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox_group, {
              modelValue: $data.checkList,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.checkList) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  label: "删除所有",
                  value: "1"
                }),
                _createVNode(_component_el_checkbox, {
                  label: "删除已使用优惠卷",
                  value: "2"
                }),
                _createVNode(_component_el_checkbox, {
                  label: "删除未领取的优惠卷",
                  value: "3"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: $data.dialogVisible2,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.dialogVisible2) = $event)),
      width: "500",
      draggable: "",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => ($data.dialogVisible2 = false))
          }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: $options.addVoucher
          }, {
            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
              _createTextVNode(" 添加 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: $data.form,
          "label-width": "auto",
          style: {"max-width":"600px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "游戏(多选)" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: $data.value1,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.value1) = $event)),
                  multiple: "",
                  filterable: "",
                  remote: "",
                  "reserve-keyword": "",
                  placeholder: "搜索游戏",
                  "remote-method": $options.remoteMethod,
                  loading: $data.loading,
                  style: {"width":"240px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "remote-method", "loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "折扣金额" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: $data.form.discountAmount,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.form.discountAmount) = $event)),
                  type: "number",
                  max: "1000",
                  onBlur: $options.handleDiscountBlur
                }, null, 8, ["modelValue", "onBlur"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "过期时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: $data.form.expirationTime,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.form.expirationTime) = $event)),
                  type: "datetime",
                  placeholder: "Pick a day",
                  onChange: $options.changeTime
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "卷数" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: $data.voucherNum,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.voucherNum) = $event)),
                  type: "number",
                  max: "300",
                  onBlur: $options.handleDiscountBlur
                }, null, 8, ["modelValue", "onBlur"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: $data.form.remark,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($data.form.remark) = $event)),
                  type: "text",
                  maxlength: "30",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}